import { Suspense, useState } from "react";
import { RoomTypeFilterProps } from "../../types";
// import PopoverFilter from "./PopOverFilter";

import classes from "./Filter.module.scss";
import Portal from "@Components/Portal";
import BottomSheetOverlay from "@Components/BottomSheetOverlay";
import FullPageLoader from "@Components/FullPageLoader";
import BottomOverlayInfoContainer from "@Pages/Search/components/FilterSection/components/BottomOverlayInfoContainer/BottomOverlayInfoContainer";
import RadioButton from "@Components/Radio";
import themeVariables from "@Theme/exportColor.module.scss";
import ArrowIcon from "@Icons/ArrowIcon";
import useIsDesktop from "hooks/useIsDesktop";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
//

const RoomTypeFilter = ({
  selectedConfig,
  isSelected,
  roomTypes,
  handleFilterChange,
}: RoomTypeFilterProps) => {
  const getRoomName = () => {
    const roomName = roomTypes.filter((room) => selectedConfig === room.value)[0]?.name;
    return t(roomName);
  };
  const isDesktop = useIsDesktop();
  const [showPopup, setShowPopup] = useState(false);
  const { t } = useTranslationHook();
  return (
    <>
      <button
        data-testid="All-Room-Types-Dropdown"
        className={formatClassNames(classes.buttonContainer, !isDesktop && classes.mobile)}
        type="button"
        style={{
          borderColor: themeVariables.neutral2,
          color: themeVariables.neutral7,
        }}
        onClick={() => setShowPopup((prev) => !prev)}
      >
        <div data-testid="Filter-Room-Type-Value" className={classes.titleText}>
          {!isSelected
            ? t("propertypage.components.pricetrends.filters.allRoomTypes")
            : getRoomName()}
        </div>
        <ArrowIcon stroke={themeVariables.neutral8} />
      </button>
      {showPopup && (
        <Portal rootId="forPortal">
          <BottomSheetOverlay
            hideBottomSheetOverlay={() => setShowPopup(false)}
            isHistoryPush={!isDesktop}
            name="RoomTypeFilterPopup"
          >
            <Suspense fallback={<FullPageLoader height="30vh" />}>
              <BottomOverlayInfoContainer
                onApplyClick={() => {
                  setShowPopup(false);
                }}
                showButton={false}
              >
                <div
                  data-testid="property-price-trend-filter-modal-name"
                  className={classes.modalTitle}
                >
                  {t("propertypage.roomtypesectiondynamic.roomtypetitle")}
                </div>
                <div className={classes.optionsContainer}>
                  {(roomTypes || []).map((room: any) => (
                    <div
                      data-testid="property-price-trend-filter"
                      className={classes.option}
                      onClick={() => {
                        handleFilterChange(room.value);
                        setShowPopup(false);
                      }}
                      role="radio"
                      aria-checked={selectedConfig === room.value}
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === " ") {
                          handleFilterChange(room.value);
                          setShowPopup(false);
                        }
                      }}
                    >
                      <RadioButton isSelected={selectedConfig === room.value} />
                      <div
                        data-testid="property-price-trend-room-name"
                        key={room.value}
                        color="primary.4"
                        className={classes.buttonWrapper}
                      >
                        {t(room.name)}
                      </div>
                    </div>
                  ))}
                </div>
              </BottomOverlayInfoContainer>
            </Suspense>
          </BottomSheetOverlay>
        </Portal>
      )}
    </>
  );
};

export default wrapperHOC(RoomTypeFilter, {
  componentName: "RoomTypeFilter-Filters-PriceTrends-PropertyPage",
  showForChina: true,
});
